import { useRef, useState } from "react";
import { CompactPictogramTile } from "./CompactPictogramTile";
import { DefaultPictogramEditor } from "./DefaultPictogramEditor";

export const DefaultPictograms = ({ items, categories, reload }) => {
  const [selectedId, setSelectedId] = useState(null);
  const triggerRef = useRef(null);
  const defaults = items.filter(p => p.is_default);
  const selected = defaults.find(p => p.id === selectedId);
  const restoreFocus = () => {
    const trigger = triggerRef.current?.isConnected ? triggerRef.current :
      document.querySelector(`[data-testid="default-picto-card-${selectedId}"]`);
    (trigger || document.querySelector('[data-testid^="default-picto-card-"]'))?.focus();
  };
  const close = () => { setSelectedId(null); setTimeout(restoreFocus, 0); };
  const groups = categories.filter(c => c.is_default)
    .map(c => ({ ...c, items: defaults.filter(p => p.category_id === c.id) }))
    .filter(group => group.items.length);

  return <section className="mb-12" data-testid="default-pictograms-section">
    <div className="border-b border-[#D4D4D4] pb-4 mb-6">
      <div className="text-[10px] uppercase tracking-luxury text-[#707070] mb-2">Libreria condivisa</div>
      <h3 className="font-serif text-2xl text-[#1A1A1A]">Pittogrammi di default</h3>
      <p className="text-sm text-[#525252] mt-2">Personalizza nome, colore e categoria per il tuo account. Le icone di default restano disponibili per tutti.</p>
    </div>
    {defaults.length === 0 && <p className="text-sm text-[#707070] py-6" data-testid="default-pictograms-empty">Non ci sono ancora pittogrammi di default.</p>}
    {groups.map(group => <div key={group.id} className="mb-8" data-testid={`default-picto-group-${group.id}`}>
      <h4 className="font-serif text-xl mb-4" data-testid={`default-picto-group-label-${group.id}`}>{group.name}</h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-7 gap-3">
        {group.items.map(p => <CompactPictogramTile key={p.id} pictogram={p}
          onOpen={event => { triggerRef.current = event.currentTarget; setSelectedId(p.id); }} testId={`default-picto-card-${p.id}`}
          imageTestId={`default-picto-image-${p.id}`} nameTestId={`default-picto-label-${p.id}`}
          badge={p.is_customized ? "Personalizzato" : null} badgeTestId={`default-picto-customized-${p.id}`} />)}
      </div>
    </div>)}
    {selected && <DefaultPictogramEditor key={selected.id} picto={selected} categories={categories}
      reload={reload} onClose={close} onReturnFocus={restoreFocus} />}
  </section>;
};